import { render, staticRenderFns } from "./StaffPayoutsHistory.vue?vue&type=template&id=633c1b34&"
import script from "./StaffPayoutsHistory.vue?vue&type=script&lang=js&"
export * from "./StaffPayoutsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports